import type { CatalogCourse } from '../../catalog/api';
import { translateUiText, type AppLanguage } from './centralLocalization';

const businessValues: Record<string,string> = {
  qualified:'Qualified', approved:'Approved', pending:'Pending', rejected:'Rejected', active:'Active', inactive:'Inactive',
  paid:'Paid', unpaid:'Unpaid', overdue:'Overdue', partial:'Partially Paid', in_progress:'In Progress',
  not_started:'Not Started', didnt_complete:'Did Not Complete', refund:'Refunded', completed:'Completed',
  cash:'Cash', card:'Card', bank_transfer:'Bank Transfer', instapay:'InstaPay', vodafone_cash:'Vodafone Cash',
  general_manager:'General Manager', sales_manager:'Sales Manager', tele_sales:'Tele-Sales',
  super_reception:'Super Reception', employee:'Employee', reception:'Reception', instructor:'Instructor',
  mentor:'Mentor', marketing:'Marketing', moderator:'Moderator', accountant:'Accountant', developer:'Developer',
};

/** Structured business labels only. Stored routing/status/course values stay exact. */
export function businessLabel(value: string, language: AppLanguage): string {
  const key = value.trim();
  const display = Object.hasOwn(businessValues,key) ? businessValues[key] : value;
  return translateUiText(display, language);
}

export function catalogCourseLabel(course: CatalogCourse, language: AppLanguage, field: 'full_name' | 'display_name' = 'display_name'): string {
  return course[`${field}_${language}`]?.trim() || businessLabel(course[field], language);
}

export function catalogCourseSearchText(course: CatalogCourse): string {
  return [course.code, course.full_name, course.display_name, course.legacy_value,
    course.full_name_ar, course.full_name_en, course.display_name_ar, course.display_name_en].filter(Boolean).join(' ');
}

/** Only explicit business-description fields; never use this helper for notes. */
export function businessDescription(record: unknown, language: AppLanguage, field = 'short_description'): string {
  if (!record || typeof record !== 'object') return '';
  const row = record as Record<string, unknown>;
  return typeof row[`${field}_${language}`] === 'string' ? row[`${field}_${language}`] as string
    : typeof row[field] === 'string' ? row[field] as string : '';
}
